import React from "react"

import LoanPayoff from "activities/calculators/early-payoff"
import merge from "lodash/merge"

export default (props) => (
  <LoanPayoff
    {...merge(
      {
        id: "student-loan-payoff", // what is this id for? I fixed the typo, but it doesn't match the id in the coach.js file, either ("student-loan")
        title: "Student Loan Calculator",
        subtitle: "Explore what it would take to pay off your student loans early.",
        amountTitle: "Loan balance",
        loanTerm: {
          min: 1,
          max: 30,
          step: 1
        },
        addedPayment: {
          min: 0,
          max: (payment) => Math.floor((payment * 5) / 100) * 100,
          step: 50
        },
        interestRate: {
          min: 0,
          max: 20,
          step: 0.05
        },
        initialState: {
          price: 10000,
          term: 10,
          rate: 6.5,
          additionalPayment: 50
        },
        ariaLabel:
          "This line graph visually represents how much sooner you could pay off your student loan. Read below to find the monthly payment, interest saved, interest to be paid, and the date the student loan will be paid off."
      },
      props
    )}
  />
)
